import React, { FC } from 'react';
import './PhoneLink.css';

interface PhoneLinkProps {
	phone: string | number
}

const PhoneLink: FC<PhoneLinkProps> = ({ phone }) => {
	const title = `Lien clicable du téléphone : ${phone}`;
	return (
	<a
	    aria-label={title}
		title={title}
		className="PhoneLink title-phone"
		data-testid="PhoneLink"
		href={'tel:' + phone}>Tél : {phone}
	</a>
);
}

export default PhoneLink;
